import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/AuthStore";
import {
  DashboardService,
  CustomerDashboardStats,
} from "@/services/DashboardService";
import { formatPublicReference } from "@/utils/formatReference";
import InquiryProgressIndicator from "@/components/InquiryProgressIndicator.vue";
import CustomerAccommodationInquiryFormDialog from "@/views/customer/CustomerAccommodationInquiryFormDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerHomeView',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
const authStore = useAuthStore();

const stats = ref<CustomerDashboardStats | null>(null);
const loading = ref(true);
const error = ref(false);

const greeting = computed(() => authStore.firstName || "Felhasználó");

const isNewUser = computed(() => {
  if (!stats.value) return false;
  const s = stats.value;
  return (
    s.activeBookingsCount === 0 &&
    s.pendingOffersCount === 0 &&
    s.allActiveInquiriesCount === 0 &&
    s.activeInquiries.length === 0 &&
    s.upcomingStays.length === 0
  );
});

const pendingOffersCount = computed(() => stats.value?.pendingOffersCount ?? 0);
const activeBookingsCount = computed(
  () => stats.value?.activeBookingsCount ?? 0
);
const upcomingStaysCount = computed(() => stats.value?.upcomingStaysCount ?? 0);
const allActiveInquiriesCount = computed(
  () => stats.value?.allActiveInquiriesCount ?? 0
);
const activeInquiries = computed(() => stats.value?.activeInquiries ?? []);
const upcomingStays = computed(() => stats.value?.upcomingStays ?? []);
const companyUsersCount = computed(() => stats.value?.companyUsersCount ?? 0);
const companyCostCentersCount = computed(
  () => stats.value?.companyCostCentersCount ?? 0
);

const dashboardService = new DashboardService();

const fetchDashboardData = async () => {
  loading.value = true;
  error.value = false;
  try {
    stats.value = await dashboardService.getCustomerStats();
  } catch (e) {
    console.error("Failed to load dashboard data", e);
    error.value = true;
  } finally {
    loading.value = false;
  }
};

const showCreateDialog = ref(false);

const openCreateDialog = () => {
  showCreateDialog.value = true;
};

const closeCreateDialog = () => {
  showCreateDialog.value = false;
};

const onInquiryCreated = () => {
  showCreateDialog.value = false;
  fetchDashboardData();
};

const navigateToInquiries = (status?: string) => {
  router.push({
    path: "/accommodationinquiries",
    query: status ? { status } : {},
  });
};

const navigateToBookings = (status?: string) => {
  router.push({ path: "/bookings", query: status ? { status } : {} });
};

const navigateToInquiryDetails = (id: number) => {
  router.push(`/inquiry/details/${id}`);
};

const navigateToBookingDetails = (publicReference: string) => {
  router.push(`/bookings/${publicReference}`);
};

const navigateToUsers = () => {
  router.push("/users");
};

const navigateToCostCenters = () => {
  router.push("/costcenters");
};

fetchDashboardData();

const __returned__ = { router, authStore, stats, loading, error, greeting, isNewUser, pendingOffersCount, activeBookingsCount, upcomingStaysCount, allActiveInquiriesCount, activeInquiries, upcomingStays, companyUsersCount, companyCostCentersCount, dashboardService, fetchDashboardData, showCreateDialog, openCreateDialog, closeCreateDialog, onInquiryCreated, navigateToInquiries, navigateToBookings, navigateToInquiryDetails, navigateToBookingDetails, navigateToUsers, navigateToCostCenters, ref, computed, get useRouter() { return useRouter }, get useAuthStore() { return useAuthStore }, get DashboardService() { return DashboardService }, get CustomerDashboardStats() { return CustomerDashboardStats }, get formatPublicReference() { return formatPublicReference }, InquiryProgressIndicator, CustomerAccommodationInquiryFormDialog }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})